import { Button, Result } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button
          type="primary"
          onClick={() => navigate("/")}
          className="h-12 px-8 border border-2 border-border text-base  bg-primary text-white border-none"
        >
          Back Home
        </Button>
      }
    />
  );
};

export default NotFound;
